module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "منزل-ناجي"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منزل ناجي")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصَل رشيد إلى منزل السّيد ناجي، وبعد أن ألقى عليه التحيَّة سلّمه المفاتيحَ وطلب منه مفاتيح الشّاحنة التي يُخبّئها في المصنع القديم بالقرب من المحطّة للطّوارئ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اجلس، سأحضر لك المفاتيح.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قال العم ناجي ذلك ثمَّ دخل إلى غرفة نومه بهدوءٍ وأخرج المفاتيح من جيب المعطف المعلّق في خزانة الملابس دون أن تشعر زوجته، وخرج من الغرفة وأغلق الباب وتفاجأ بابنته سارة في الممرِّ المؤدّي إلى الصالة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألَتهُ: ماذا هناك يا أبي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همس ناجي: صه، اذهبي ونامي يا بنتي! لا أريد لشقيقتِكِ فاتن أن تستيقظ وتراه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرت سارة ناحية الصّالة وقالَت: أهذا رشيد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هزّ برأسه ثمَّ دخل الصّالة وسحب الكرسيَّ وجلس، ثمَّ وضع المفاتيح أمام رشيد، نظر رشيد إلى المفاتيح ثمَّ سرح. نظرَ إليهِ العمّ ناجي وقالَ: أتفكِّرُ فيهم؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رفع رشيد رأسه ونظر إلى العمِّ ناجي:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا أفكِّر في أحد سِوَاهم، أتمنّى لو أستطيع توديع أمّي وأولادي يا عمّ ناجي، لم أرهم منذُ شهورٍ والآن سأغادر المدينة ولا أعرف متى أراهم ثانيةً!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كانت لديكَ فرصة لكنك لم تستغلّها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتسم رشيد وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كيف؟ لو رآني والدي لأمر رجالَه أن يُمسِكوا بي ويرموني في مخزن \"الفيلّا\" مقيّدًا بالسَّلاسل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كأنَّك تتحدّث عن عدوّك وليس والدك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هو كذلك، أنت تعرف كلَّ شيءٍ ولا داعي لأن أعيد لك ما فعله بنا كمال باشا، أنسيتَ كيف أجبرني على الزّواج بابنة شريكه من أجل مصالِحه الشخصيَّة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وأنتَ أجبرتَه على الاستقالة من الوزارة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هذا جزاءُ الوزراء الفاسِدين في هذا البلد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتعتقد أنّك فعلتَ الصّواب؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لقد أرحتُ النّاس من شرّ أحدهم على الأقلّ، والباقي سيأتي دَوْرهم تباعًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كان مُجرّد انتقامٍ شخصيٍّ، فوالدك رجلٌ نزيهٌ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وماذا يفعل رجلٌ نزيهٌ في مثل هذه الحكومة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت تخلط بين الانتقام وبين عملك يا رشيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت تقول هذا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنت تستغلُّ عملك فقط للانتقام من والدك الَّذي أجبرك على الزّواج من ابنةِ شريكه، ولأنَّه ظلم والدتك وأخوتك، مقالاتُك كلّها ضدّه وكأن الحُكومة فقط كمال الرشيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وفساده يا عمّ ناجي! تتكلّم وكأنَّك لا تعرف أنَّه يستغلُّ منصِبه لمصالحه الشخصيَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كما تستغلُّ قلمك في انتقامك الشخصيّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ رشيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- اسمع، إن كان حقًّا هدفك العمل من أجل تحقيق هذه الشّعارات الَّتي ترفعها أنت وأصحابك، فاترك فكرة الانتقام من والدك، واجعل ما تقم به فقط من أجل هذا الوطن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا مؤمنٌ بأفكاري ومخلصٌ لهذا الوطن، ولكنّني أيضًا لا أنسى الظُّلم الَّذي لَحِق بي وبعائلتي من هذا الرّجل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- الصحفيُّ المناضل الَّذي يحمل هموم الوطن والمواطن بدل من أن يعمل من أجل قضيَّته جعل من قضيَّته جسرًا للوصول لأغراضه الشخصيَّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان ذلك صوتًا أنثويًّا قادمًا من عند باب الصّالة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يلتَفت ناجي ونظر إلى الأسفل، ولكن رشيد نظر إليها بطرف عينهِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاول ناجي إسكاتها: فاتن!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهض رشيد من مكانه وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- دعها، فأنا أتفهَّم سبب انزعاجها منّي، لأنَّه بسببي رجع أبي إلى عمله الخاصّ بعد أن قدَّم استقالته من الوزارة، ورجع الأستاذ عدنان خطيب الآنسة فاتن لمنصبه القديم؛ أيّ إنَّه أصبح مجرَّد مُحامٍ عاديٍّ في الشّركة بعد أن كان المدير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47502448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch012.vue
// module id = 93
// module chunks = 0